import React from "react";
import {Tracking} from "./Tracking";

const TrackingPage = () => {
  return (
      <Tracking />
  );
}

export default TrackingPage;